import { render } from "./FormTextarea.vue?vue&type=template&id=1cc8254e"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__